const collapseSpaceBeforePunctuation = html =>
  String(html || "").replace(/ (\.|,|;|:)/g, "$1");

module.exports = {
  collapseSpaceBeforePunctuation
};
